/*
 * Copyright 2018 - 2021 Swiss Federal Institute of Technology Lausanne (EPFL)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * This open source software code was developed in part or in whole in the
 * Human Brain Project, funded from the European Union's Horizon 2020
 * Framework Programme for Research and Innovation under
 * Specific Grant Agreements No. 720270, No. 785907, and No. 945539
 * (Human Brain Project SGA1, SGA2 and SGA3).
 *
 */

interface Types {
  [key: string]: string[];
}

const TYPES = {
  dataset:[
    "https://openminds.ebrains.eu/core/DatasetVersion",
    "https://openminds.ebrains.eu/core/Dataset",
    "https://openminds.ebrains.eu/core/DOI",
    "https://openminds.ebrains.eu/core/FileRepository",
    "https://openminds.ebrains.eu/core/Subject",
    "https://openminds.ebrains.eu/core/SubjectState",
    "https://openminds.ebrains.eu/core/SubjectGroup",
    "https://openminds.ebrains.eu/core/SubjectGroupState",
    "https://openminds.ebrains.eu/core/TissueSample",
    "https://openminds.ebrains.eu/core/TissueSampleState",
    "https://openminds.ebrains.eu/core/TissueSampleCollection",
    "https://openminds.ebrains.eu/core/TissueSampleCollectionState",
    "https://openminds.ebrains.eu/core/Consortium",
    "https://openminds.ebrains.eu/core/Funding",
    "https://openminds.ebrains.eu/core/Organization",
    "https://openminds.ebrains.eu/core/Person",
    "https://openminds.ebrains.eu/core/Project",
    "https://openminds.ebrains.eu/controlledTerms/TermSuggestion",
    "https://openminds.ebrains.eu/core/Protocol",
    "https://openminds.ebrains.eu/core/ProtocolExecution"  
  ],
  software:[
    "https://openminds.ebrains.eu/core/SoftwareVersion",
    "https://openminds.ebrains.eu/core/Software",
    "https://openminds.ebrains.eu/core/DOI",
    "https://openminds.ebrains.eu/core/FileRepository",
    "https://openminds.ebrains.eu/core/Consortium",
    "https://openminds.ebrains.eu/core/Funding",
    "https://openminds.ebrains.eu/core/Organization",
    "https://openminds.ebrains.eu/core/Person",
    "https://openminds.ebrains.eu/core/Project",
    "https://openminds.ebrains.eu/controlledTerms/TermSuggestion"
  ]
} as Types;

export default TYPES;
